if (!customElements.get('japanime-hot-now')) {
  customElements.define(
    'japanime-hot-now',
    class JapanimeHotNow extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-hot-now-rail]');
        this.controls = this.querySelector('[data-hot-now-controls]');
        this.previous = this.querySelector('[data-hot-now-previous]');
        this.next = this.querySelector('[data-hot-now-next]');
        if (!this.rail || !this.controls || !this.previous || !this.next) return;

        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.rail.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.rail);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        const slide = this.rail.querySelector('.jp-hot-now__slide');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.rail.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const hasOverflow = maximum > 2;
        this.controls.hidden = !hasOverflow;
        this.previous.disabled = !hasOverflow || this.rail.scrollLeft <= 2;
        this.next.disabled = !hasOverflow || this.rail.scrollLeft >= maximum - 2;
      }
    },
  );
}
